module.exports = __webpack_public_path__ + "img/user_login.98cf8a6c.svg";